class ZoProductDetails extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced === 'true') return;

    const content = this.querySelector('[data-zo-product-details-content]');
    if (!content) return;

    content.querySelectorAll('li').forEach((item) => {
      const hasMeaningfulMedia = item.querySelector('img, video, svg, a[href]');
      if (!item.textContent.trim() && !hasMeaningfulMedia) item.remove();
    });

    const terminology = new Map([
      ['construction', 'Process'],
      ['surface material', 'Face'],
      ['face material', 'Face'],
      ['core material', 'Core'],
      ['handle perimeter', 'Handle circumference'],
      ['paddle thickness', 'Thickness'],
      ['paddle weight', 'Weight'],
      ['target balance point', 'Balance point'],
    ]);

    const performanceLabels = new Set(['paddle weight', 'weight', 'target balance point', 'balance point', 'twist weight', 'swing weight']);
    const groupedItems = {
      construction: [],
      dimensions: [],
      performance: [],
    };

    content.querySelectorAll('h2').forEach((heading) => {
      let list = heading.nextElementSibling;
      while (list && !['UL', 'OL'].includes(list.tagName)) list = list.nextElementSibling;
      if (!list) return;

      const groupName = heading.textContent.trim().toLowerCase();
      list.querySelectorAll(':scope > li').forEach((item) => {
        const strong = item.querySelector('strong');
        if (!strong) return;

        const copy = item.cloneNode(true);
        copy.querySelector('strong')?.remove();

        const originalLabel = strong.textContent.trim().replace(/:\s*$/, '');
        const labelKey = originalLabel.toLowerCase();
        const normalizedLabel = terminology.get(labelKey) || originalLabel;
        let normalizedValue = copy.textContent
          .trim()
          .replace(/^[:\s–—-]+/, '')
          .replace(/(\d)\s*\*\s*(\d)/g, '$1 × $2')
          .replace(/(\d)\s*(mm|cm|g)\b/gi, '$1 $2')
          .replace(/^approximately\s+/i, 'Approx. ');

        normalizedValue = normalizedValue
          .replace(/^Thermoformed construction$/i, 'Thermoformed')
          .replace(/Four-layer carbon-fiber face:\s*three layers of T700 carbon fiber\s*\+\s*one layer of Toray carbon fiber/i, 'Quad-Ply Toray T700 Carbon Architecture')
          .replace(/Four-layer carbon (?:fiber|face)\s*[—:-]\s*3\s*×?\s*T700\s*\+\s*1\s*×?\s*Toray carbon fiber/i, 'Quad-Ply Toray T700 Carbon Architecture')
          .replace(/^Approx\.\s*10\.5\s*cm$/i, 'Approx. 105 mm')
          .replace(/^Approx\.\s*(\d+\s*±\s*\d+\s*g)$/i, '$1');

        if (!normalizedValue) return;

        let targetGroup = 'dimensions';
        if (groupName.includes('construction')) {
          targetGroup = 'construction';
        } else if (performanceLabels.has(labelKey) || performanceLabels.has(normalizedLabel.toLowerCase())) {
          targetGroup = 'performance';
        }

        groupedItems[targetGroup].push({ label: normalizedLabel, value: normalizedValue });
      });
    });

    const productHandle = this.dataset.productHandle || '';
    if (!groupedItems.performance.length && productHandle.includes('concept-01')) {
      groupedItems.performance.push(
        { label: 'Balance point', value: 'Approx. 245 mm' },
        { label: 'Twist weight', value: '6.2' },
        { label: 'Swing weight', value: '118' }
      );
    }

    const groupDefinitions = [
      { key: 'construction', index: '01 /', title: 'Construction' },
      { key: 'dimensions', index: '02 /', title: 'Dimensions' },
      { key: 'performance', index: '03 /', title: 'Measured Performance' },
    ];
    const groups = document.createElement('div');
    groups.className = 'zo-product-details-panel__groups';

    groupDefinitions.forEach(({ key, index, title }) => {
      const items = groupedItems[key];
      if (!items.length) return;

      const group = document.createElement('details');
      group.className = 'zo-product-details-panel__group';
      group.dataset.group = key;
      group.open = true;

      const summary = document.createElement('summary');
      const number = document.createElement('span');
      number.className = 'zo-product-details-panel__group-index';
      number.textContent = index;
      const heading = document.createElement('span');
      heading.className = 'zo-product-details-panel__group-title';
      heading.textContent = title;
      summary.append(number, heading);

      const list = document.createElement('dl');
      items.forEach(({ label, value }) => {
        const row = document.createElement('div');
        row.className = 'zo-product-details-panel__row';
        const term = document.createElement('dt');
        term.textContent = label;
        const description = document.createElement('dd');
        description.textContent = value;
        row.append(term, description);
        list.append(row);
      });

      group.append(summary, list);
      groups.append(group);
    });

    if (!groups.children.length) return;
    content.replaceChildren(groups);

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const setDisclosureState = (query) => {
      groups.querySelectorAll('.zo-product-details-panel__group').forEach((group) => {
        group.open = !query.matches || group.dataset.group === 'dimensions';
      });
    };
    setDisclosureState(mobileQuery);
    mobileQuery.addEventListener?.('change', setDisclosureState);

    this.dataset.enhanced = 'true';
  }
}

if (!customElements.get('zo-product-details')) {
  customElements.define('zo-product-details', ZoProductDetails);
}
